// import { Navigate, Outlet } from "react-router-dom";

// // Example: props.allowedRoles = ["Admin", "Seller"]
// const RoleProtectedRoute = ({ allowedRoles }) => {
//     const user = JSON.parse(localStorage.getItem("loginDetails"));

//     const userRole = user?.role_id;

//     console.log(userRole)

//     console.log(allowedRoles.includes(userRole))

//     if (!userRole) {
//         return <Navigate to="/" replace />;
//       }
    
//       return allowedRoles.map(Number).includes(userRole) ? <Outlet /> : <Navigate to="/" replace />;
// };

// export default RoleProtectedRoute;
import { Navigate, Outlet } from "react-router-dom";
import Cookies from "js-cookie";

const RoleProtectedRoute = ({ allowedRoles }) => {
  // Support reading loginDetails from cookies or localStorage
  const rawLogin = Cookies.get("loginDetails") || localStorage.getItem("loginDetails");
  let user = null;
  try {
    if (rawLogin) {
      const parsed = typeof rawLogin === "string" ? JSON.parse(rawLogin) : rawLogin;
      user = parsed?.user || parsed;
    }
  } catch (e) {
    // ignore parse errors
  }

  const userRoleRaw = user?.role_id ?? user?.role ?? null;
  const userRole = Number(userRoleRaw);

  // If we couldn't determine a numeric role, block access
  if (!userRole) {
    return <Navigate to="/?login=true" replace />;
  }

  const allowed = allowedRoles.map(Number);

  return allowed.includes(userRole) ? <Outlet /> : <Navigate to="/" replace />;
};

export default RoleProtectedRoute;